import React, { memo, forwardRef } from "react";
const SvgAlphabetK = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.03 21.62c.173.187.287.36.34.52.053.16.08.293.08.4 0 .333-.113.62-.34.86-.213.227-.494.34-.84.34-.2 0-.387-.047-.56-.14-.174-.093-.367-.253-.58-.48l-4.12-4.48h-.06v3.76c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.908.908 0 01-.4.18c-.133.04-.247.06-.34.06-.094 0-.213-.02-.36-.06a1.065 1.065 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7V9.6c0-.28.04-.507.12-.68.093-.187.2-.327.32-.42.133-.093.267-.153.4-.18.146-.04.266-.06.36-.06.093 0 .207.02.34.06.146.027.28.087.4.18.133.093.24.233.32.42.093.173.14.4.14.68V18h.06l3.9-3.82c.32-.32.653-.48 1-.48.333 0 .6.107.8.32.213.213.32.473.32.78 0 .147-.034.3-.1.46-.067.16-.2.333-.4.52l-2.82 2.5 3.32 3.34z"
      />
    </svg>
  );
});
SvgAlphabetK.displayName = "SvgAlphabetK";
const MemoForwardRef = memo(SvgAlphabetK);
export default MemoForwardRef;
